import { PageBackground, StateCard } from '../quote-page/styled'

const NotFoundPage = () => (
  <PageBackground $brand="#6d28d9" $accent="#ede9fe">
    <StateCard>
      Nothing to see here. Quotes open from the private link sent to you by
      email or text.
    </StateCard>
  </PageBackground>
)

export default NotFoundPage
